import React, { useEffect, useMemo, useState } from "react";
import { Table, DatePicker } from "antd";
import { Link } from "react-router-dom";
import { FaFirstAid } from "react-icons/fa";
import infoImage from "../../Images/info-icon.svg";
import "react-circular-progressbar/dist/styles.css";
import "../../Styles/styles-ACWRTable.css";
import { formattedPlayerName } from "../../Utils/name_utils";
import { getAcwrLimits } from "@utils/acwr_utils";
import "react-circular-progressbar/dist/styles.css"
import Highcharts from 'highcharts';
import highchartsMore from "highcharts/highcharts-more";
import HighchartsReact from 'highcharts-react-official';
import { Navbar } from "../Navigation/Navbar";
import { useDataAccess, DataAccessDenied } from "@components/PermissionedComponents";
import { useDispatch, useSelector } from "react-redux";
import {
  setPlayerFilter,
} from "../../store/actions/player.actions";
import dayjs from "dayjs";
import { createGaugeOptions } from "../../mappers/model/GaugeMapper"
import { healthyMean } from "../../Utils/injury.mjs";
import { TrainingAPI } from "../../api/TrainingAPI";
import { PositionSelect } from "../PositionSelect/PositionSelect";
import { contentMap } from "../Overview/Overview"
import Popout from "../Common/Popout";

highchartsMore(Highcharts);

export const WeeklyBuckets = (props) => {
  const dateFormat = "YYYY-MM-DD";
  const dispatch = useDispatch();
  const [filterDate, setFilterDate] = useState(dayjs());
  const [overviewACWRData, setOverviewACWRData] = useState(null);
  const [filteredRowData, setFilteredRowData] = useState(null);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [showTablePopout, setShowTablePopout] = useState(false);
  const [tablePopoutContent, setTablePopoutContent] = useState(null);
  const [loading, setLoading] = useState(null);
  let trainingAPI = new TrainingAPI();
  const {
      positions,
      info: { display_name: teamName, acwr_threshold_config: acwrThresholdConfig },
    } = useSelector(({ team }) => team);

  // Weekly buckets are ACWR, i.e. GPS-derived.
  const { canAccess, ready: permissionsReady, isDenied: isDataDenied } = useDataAccess();

  const team_acwr_get = () => {
    if (!canAccess("gps")) return;
    setLoading(true);
    trainingAPI
      .getTeamACWR({ date: filterDate.format(dateFormat), weekly: true })
      .then((data) => {
        setOverviewACWRData(data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    // The ACWR endpoint 403s without AccessGpsData.
    if (!permissionsReady) return;
    team_acwr_get();
  }, [filterDate, permissionsReady])

  const handleRedirectToPlayer = (data) => () => {
    if (data.player_id) {
      dispatch(setPlayerFilter(data.player_id));
    }
  };

  const displayTablePopout = (str) => {
    const acwrLimits = getAcwrLimits(acwrThresholdConfig);
    setTablePopoutContent(contentMap(str, acwrLimits.lower, acwrLimits.upper));
    setShowTablePopout(true);
  };

  let columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      showSorterTooltip: false,
      sortDirections: ["descend", "ascend"],
      sorter: {
        compare: (a, b) => {
          if (a.name === "Team") return 0;
          if (b.name === "Team") return 0;
          else return (a.name ?? "").localeCompare(b.name ?? "");
        },
        multiple: 1,
      },
      render: (name, data) => {
        if (name === "Team") {
          return {
            props: {
              style: { width: "270px", margin: "0", padding: "0px" },
            },
            children: (
              <Link
                style={{ color: "black" }}
                className="nav-link"
                to={{
                  pathname: "/teamdata",
                }}
              >
                {name}
              </Link>
            ),
          };
        } else if (data["color"] === "yellow") {
          return {
            props: {
              style: { width: "270px", margin: "0", padding: "0px" },
            },
            children: (
              <Link
                style={{ color: "black" }}
                className="nav-link"
                to={{
                  pathname: "/playerdata",
                }}
                onClick={handleRedirectToPlayer(data)}
              >
                {formattedPlayerName(teamName, name)}
                <FaFirstAid className="injury-icon-yellow" size={17} />
              </Link>
            ),
          };
        } else if (data["color"] === "red") {
          return {
            props: {
              style: { width: "270px", margin: "0", padding: "0px" },
            },
            children: (
              <Link
                style={{ color: "black" }}
                className="nav-link"
                to={{
                  pathname: "/playerdata",
                }}
                onClick={handleRedirectToPlayer(data)}
              >
                {formattedPlayerName(teamName, name)}
                <FaFirstAid className="injury-icon" size={17} />
              </Link>
            ),
          };
        } else if (data["color"] === "yellow") {
          return {
            props: {
              style: { width: "270px", margin: "0", padding: "0px" },
            },
            children: (
              <Link
                style={{ color: "black" }}
                className="nav-link"
                to={{
                  pathname: "/playerdata",
                  state: { name: name },
                }}
              >
                {formattedPlayerName(teamName, name)}
                <FaFirstAid className="injury-icon-yellow" size={17} />
              </Link>
            ),
          };
        } else {
          return {
            props: {
              style: {
                width: "270px",
                margin: "0",
                padding: "0px",
              },
            },
            children: (
              <Link
                style={{ color: "black" }}
                className="nav-link"
                to={{
                  pathname: "/playerdata",
                  state: { name: name },
                }}
              >
                {" "}
                {formattedPlayerName(teamName, name)}
              </Link>
            ),
          };
        }
      },
    },
  ];

  for (let i = 0; i < overviewACWRData?.metrics.length; i++) {
    let metric = overviewACWRData?.metrics[i];
    let key = metric["key"];
    let metricKey = key;
    let name = metric["name"];
    columns.push({
      title: (
        <span className="tabel_header_section">
          <img
            src={infoImage}
            alt="inof-img"
            onClick={() => displayTablePopout(name)}
          />
          {name}
        </span>
      ),
      dataIndex: key,
      key: key,
      sortDirections: ["descend", "ascend"],
      // sortDirections: ["descend"],
      align: 'center',
      showSorterTooltip: false,
      sorter: {
        compare: (a, b) => {
          if (a.name === "Team") return 0;
          if (b.name === "Team") return 0;
          return a[key] - b[key];
        },
        multiple: columns.length + 1,
      },
      render(key, rest) {
        // A Team row with no healthy player in the position has no value to show.
        if (key == null && rest?.name === "Team") {
          return { children: <div style={{ width: '9rem', margin: '0 auto' }} /> };
        }
        const max = rest[metricKey + "_max"];
        const options = createGaugeOptions(key, max)
        return {
          // <GaugeChart value={key} max={rest[metricKey+'_max']}/>
          children:    
          <div style={{
            width: '9rem',
            margin: '0 auto' 
          }}>
            <HighchartsReact
              highcharts={Highcharts}
              options={{...options, chart: {...options?.chart, height: '75%'}}}
            />
          </div>
        };
      },
    });
  }

  columns.push({
    title: (
      <span className="tabel_header_section">
        <img
          src={infoImage}
          alt="inof-img"
          onClick={() => displayTablePopout("overall")}
        />
        Overall
      </span>
    ),
    dataIndex: "overall",
    key: "overall",
    sortDirections: ["descend", "ascend"],
    showSorterTooltip: false,
    sorter: {
      compare: (a, b) => {
        console.log(a, b);
        if (a.name === "Team") return 0;
        if (b.name === "Team") return 0;
        return a.overall - b.overall;
      },
      multiple: columns.length + 1,
    },
    render(overall, { overall_max }) {
      const options = createGaugeOptions(overall, overall_max)
      return {        
        children:    
          <div style={{width:'9rem', margin: '0 auto' }}>
            <HighchartsReact
              highcharts={Highcharts}
              options={{...options, chart: {...options?.chart, height: '75%'}}}
            />
          </div>
      };
    },
  });

  useEffect(() => {
    if (overviewACWRData?.data && overviewACWRData?.data?.length > 0) {
      if (selectedPosition) {
        let filteredData = overviewACWRData?.data.filter(
          (x) => x.position === selectedPosition || x.name == "Team"
        );

        let teamRowData = structuredClone(filteredData.filter((x) => x.name == "Team"));
        let posRowData = structuredClone(filteredData.filter((x) => x.position === selectedPosition));
        if (teamRowData.length !== 1) {
          teamRowData = [{}];
        }

        for (let i = 0; i < overviewACWRData?.metrics.length; i++) {
          const metricKey = overviewACWRData?.metrics[i]?.key;
          const bucketMultiplier = overviewACWRData?.metrics[i]?.weekly_bucket_multiple;
          const decimalPlaces = overviewACWRData?.metrics[i]?.decimal_places;

          const metricValsAvg = healthyMean(posRowData, d => d[metricKey]);
          const metricMaxValsAvg = healthyMean(posRowData, d => d[`${metricKey}_max`]);

          // The clone holds the whole-team value, so a null is written, never skipped.
          teamRowData[0][metricKey] = metricValsAvg === null ? null : Number((metricValsAvg).toFixed(decimalPlaces))
          teamRowData[0][`${metricKey}_max`] = metricMaxValsAvg === null ? null : Number((metricMaxValsAvg).toFixed(0))
        }

        setFilteredRowData(structuredClone([...teamRowData, ...posRowData]));
      } else {
        setFilteredRowData(structuredClone([...overviewACWRData?.data]));
      }
    }
  }, [overviewACWRData, selectedPosition]) ;
  
  const handleDateChange = (value, dateString) => {
    setFilterDate(value);  
  }
  
  const positionChange = (e) => {
    setSelectedPosition(e);
  };

  if (isDataDenied("gps")) {
    return (
      <>
        <Navbar />
        <DataAccessDenied streams={["gps"]} />
      </>
    );
  }

  return (
    <>
        <Navbar />
        <div className="weekly-bucket-table-container">
          <div className="weekly-bucket-filter-container">
            <PositionSelect
              value={selectedPosition}
              handleChange={positionChange}
              options={positions}
              width="10vw"
            />
            <DatePicker
              className="weekly-bucket-date-picker"
              onChange={handleDateChange}
              value={filterDate}
              allowClear={false}
            />
          </div>
          <div className="weekly-bucket-acwr-table">
            <Popout
              showPopout={showTablePopout}
              setShowPopout={setShowTablePopout}
              popOutStyles={{ paddingTop: "12%", paddingLeft: "30%" }}
            >
              {tablePopoutContent}
            </Popout>
            <Table
              style={{
                marginTop: overviewACWRData?.data?.length <= 0 ? "73px" : "unset",
                width: "100%",
              }}
              rowKey="rowId"
              columns={columns}
              size="middle"
              dataSource={filteredRowData}
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "30"],
                position: ["topLeft"],
                simple: true,
              }}
              loading={loading}
            />
          </div>
        </div>
    </>
  );
}
